<kendo-multiselect [data]="dataWG" style="width: 300px;" [virtual]="virtual"
[textField]="'bezeichnung'" [valueField]="'warengruppennr'" [valuePrimitive]="true"
formControlName="filterWarengruppen" [placeholder]="'Warengruppen auswählen...'">
<ng-template kendoMultiSelectItemTemplate let-dataItem>
    <b>{{ dataItem.bezeichnung + " " }}</b>: {{ dataItem.warengruppennr }}

</ng-template>
</kendo-multiselect>